export default "/assets/images/mila-feed-11.mp4?55d576c31a4f0a2ba474649d9aa7fe09";